import type { HotCard } from '../types';

// 热门卡片 Mock 数据
// 后续可替换为后端 API
export const hotCardsMock: HotCard[] = [
  {
    id: 'pikachu-vmax',
    name: '皮卡丘 VMAX',
    image: 'https://images.pokemontcg.io/swsh4/44_hires.png',
    number: 'SWSH4-44',
  },
  {
    id: 'charizard-vstar',
    name: '喷火龙 VSTAR',
    image: 'https://images.pokemontcg.io/swsh9/18_hires.png',
    number: 'SWSH9-18',
  },
  {
    id: 'umbreon-vmax',
    name: '月亮伊布 VMAX',
    image: 'https://images.pokemontcg.io/swsh7/95_hires.png',
    number: 'SWSH7-95',
  },
  {
    id: 'mew-vmax',
    name: '梦幻 VMAX',
    image: 'https://images.pokemontcg.io/swsh8/114_hires.png',
    number: 'SWSH8-114',
  },
  {
    id: 'rayquaza-vmax',
    name: '烈空坐 VMAX',
    image: 'https://images.pokemontcg.io/swsh7/111_hires.png',
    number: 'SWSH7-111',
  },
  {
    id: 'gengar-vmax',
    name: '耿鬼 VMAX',
    image: 'https://images.pokemontcg.io/swsh8/157_hires.png',
    number: 'SWSH8-157',
  },
  {
    id: 'arceus-vstar',
    name: '阿尔宙斯 VSTAR',
    image: 'https://images.pokemontcg.io/swsh9/123_hires.png',
    number: 'SWSH9-123',
  },
  {
    id: 'mewtwo-vstar',
    name: '超梦 VSTAR',
    image: 'https://images.pokemontcg.io/pgo/31_hires.png',
    number: 'PGO-31',
  },
];
